import { ApolloError, useQuery } from "@apollo/client";
import { GET_VARIABLE } from "graphql/queries";

export type ConfigurationItem = {
    sysId: string;
    name: string;
};

export function useReference(
    companySysId: string | undefined,
    refName: string
): [ConfigurationItem[], boolean, ApolloError | undefined] {
    const { data, loading, error } = useQuery<{ configurationItems: ConfigurationItem[] }>(GET_VARIABLE, {
        variables: { className: refName, query: { company: companySysId } },
        errorPolicy: "all",
        skip: !companySysId || !refName,
        notifyOnNetworkStatusChange: true
    });

    return [data ? data.configurationItems : [], loading, error];
}
